/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/* Services */

/**
 * Renders Wisdom Banner Component 
 *
 * @param {string} title - Title of Component 
 * @param {string} size - Size of Banner
 * @returns {ReactElement} Wisdom Banner Component
 */
export default function WisdomBanner({ title = 'Wisdom', size, lang }) {
  return (
    <Box
      maxW={size === 'small' ? '1300px' : '1190px'}
      m="0 auto 4vw auto"
      height={{ base: 'auto' }}
      padding={{ base: '30px 0 45px 0', md: '30px' }}
      bgImage={`url('${config.imgPath}/d/46272/1663638990-header-texture-2x.jpg')`}
      /*bgImage={
        'https://images.sadhguru.org/profiles/isha/modules/custom/isha_topic_page/images/header-texture@2x.jpg'
      }*/
      bgSize="100% 100%"
    >
      <Text
        p={size === 'small' ? '0 8.5vw' : '0 13vw'}
        textAlign="left"
        fontFamily={lang === 'ta' ? 'MuktaMlalar' : 'FedraSerifAStdBook'}
        fontSize={{
          base: title?.length < 30 ? '25px' : '30px',
          lg: title?.length < 30 ? '54px' : '30px',
        }}
        color="#eae3d4"
        textTransform="capitalize"
        lineHeight="1.2"
      >
        {title}
      </Text>

      {lang === 'ta' && (
        <Text
          p={size === 'small' ? '0 0 0 8.5vw' : '0 13vw'}
          fontFamily="MuktaMalar"
          fontSize="16px"
          color="#ffffff"
          maxWidth="780px"
        >
          ஒரு புதிய தரிசனத்தைப் பெற விரும்புகிறீர்களா? கட்டுரைகள், வீடியோக்கள்,
          குருவாசகங்கள், ஆடியோ பதிவேற்றங்கள் மற்றும் பலவற்றின் மூலம் சத்குருவின்
          ஞானம் & உள்நிலை பார்வைகளை ஆராய்ந்தறியுங்கள்.
        </Text>
      )}
      {lang !== 'ta' && (
        <Text
          p={size === 'small' ? '0 0 0 8.5vw' : '0 13vw'}
          fontFamily="FedraSerifAStdBook"
          fontSize="16px"
          color="#ffffff"
          maxWidth="780px"
        >
          Want to get a fresh perspective on {title}? Explore Sadhguru’s wisdom
          and insights through articles, videos, quotes, podcasts and more.
        </Text>
      )}
    </Box>
  );
}
